import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { imageIcon } from "../data/imagePath";

function checkActive(menuPath, currentPath) {
  if (!menuPath || !currentPath) return false;
  
  // Normalize paths (remove trailing slash and convert to lowercase)
  const menu = menuPath.toLowerCase().replace(/\/$/, "");
  const current = currentPath.toLowerCase().replace(/\/$/, "");

  if (menu === current) return true;

  if (menu === "") return false;

  // If current path starts with menu path followed by a slash (sub-pages)
  if (current.startsWith(menu + "/")) return true;

  // Get path segments
  const menuSegments = menu.split("/").filter(Boolean);
  const currentSegments = current.split("/").filter(Boolean);

  if (menuSegments.length === 0 || currentSegments.length === 0) return false;

  // Normalize plural 's' at the end of segments
  const m0 = menuSegments[0].replace(/s$/, "");
  const c0 = currentSegments[0].replace(/s$/, "");
  
  if (m0 === c0) {
    const isMainPage = 
      menuSegments.length === 1 || 
      menuSegments.includes("list") || 
      menuSegments.includes("userlist");

    const isSubPage = 
      currentSegments.includes("profile") || 
      currentSegments.includes("edit") || 
      currentSegments.includes("details") || 
      currentSegments.includes("add") ||
      currentSegments.includes("history");

    if (isMainPage && isSubPage) {
      return true;
    }
  }

  // Handle special cases
  const cleanStr = (str) => str.replace(/[-_s]/g, "").replace("reqest", "request");
  const mClean = cleanStr(menuSegments[0]);
  const cClean = cleanStr(currentSegments[0]);

  // buyerReqest vs buyerRequest
  if (mClean === cClean && (menuSegments.includes("list") || menuSegments.length === 1)) {
    return true;
  }

  // free-contest vs contest
  if (
    (mClean.includes("contest") && cClean.includes("contest")) &&
    !(mClean.includes("question") || cClean.includes("question"))
  ) {
    if (menuSegments.includes("list")) {
      return true;
    }
  }

  // confirmWarehouseRequests vs buyerReqest/buyerRequest
  if (
    (mClean.includes("buyerrequest") || mClean.includes("retailerrequest") || mClean.includes("buyerreqest")) &&
    cClean.includes("confirmwarehouserequest")
  ) {
    if (menuSegments.includes("list") || menu.includes("confirmed")) {
      return true;
    }
  }

  return false;
}

export function SideMenuItems({ item, activeMenu, setActiveMenu }) {
  const location = useLocation();
  const navigate = useNavigate();
  const submenuRef = useRef(null);

  // Check if any submenu item is active based on the current route
  const isSubMenuActive = item.submenu?.some(
    (subItem) => checkActive(subItem.path, location.pathname)
  );
  const isSubMenuOpen = activeMenu === item.title;

  // Keep submenu open if any submenu item is active
  useEffect(() => {
    if (isSubMenuActive) {
      setActiveMenu(item.title);
    }
  }, [isSubMenuActive, item.title, setActiveMenu]);

  const handleMenuClick = () => {
    // Toggle submenu: close if open, open if closed
    setActiveMenu(isSubMenuOpen ? null : item.title);
  };

  return (
    <div className={`sideMenu-item ${isSubMenuOpen ? "openActive" : ""}`}>
      {item.path ? (
        <Link
          to={item.path}
          className={`submenu_item sigleLink  ${
            checkActive(item.path, location.pathname) ? "navActive" : ""
          }`}
          style={{ paddingLeft: "10px" }}>
          <img
            src={imageIcon[item.icon]}
            alt=""
            className="submenu_icon"
          />
          <span className="suLinknk">{item.title}</span>
        </Link>
      ) : (
        <div
          className={`sideLink ${isSubMenuActive ? "navActive" : ""}`}
          onClick={handleMenuClick} // Toggles menu open/close
        >
          <div className="sideLink_item">
            <img
              src={imageIcon[item.icon]}
              alt=""
              className="sidelink_icon"
            />
            <span>{item.title}</span>
          </div>
          {item.submenu && (
            <img
              src={imageIcon.sideRight}
              alt=""
              className="sideArrow"
            />
          )}
        </div>
      )}
      {item.submenu && (
        <ul
          className={`submenu ${isSubMenuOpen ? "active" : ""}`}
          ref={submenuRef}
          style={{
            height: isSubMenuOpen ? submenuRef.current?.scrollHeight : 0,
          }}>
          {item.submenu.map((subItem, index) => (
            <Link
              key={index}
              className={`submenu_item ${
                checkActive(subItem.path, location.pathname) ? "navActive" : ""
              }`}
              to={subItem.path}>
              <img
                className="submenu_icon"
                src={imageIcon[subItem.icon]}
                alt=""
              />
              <div className="suLinknk">{subItem.title}</div>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}

